export function TelegramIcon({ className = "w-4 h-4" }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M9.993 16.233 9.727 20.1c.36 0 .516-.155.705-.34l1.69-1.617 3.504 2.566c.643.354 1.1.17 1.27-.595l2.3-10.77h.001c.2-.93-.337-1.293-.964-1.06L3.76 11.4c-.91.355-.897.865-.155 1.095l4.154 1.297 9.65-6.088c.455-.295.868-.132.528.164-.034.027-9.65 8.71-9.95 9.165" />
    </svg>
  );
}
